import Api from "@/config/api";
import request from "@/utils/request";
export default {
  // 注册
  signUp: ({ payload, ...props }) => {
    return request(Api.signUp, { body: payload, ...props });
  },
  // 登录
  login: ({ payload, ...props }) => {
    return request(Api.login, { body: payload, ...props });
  },
  // userinfo
  userinfo: ({ payload, ...props }) => {
    return request(Api.userinfo, { body: payload, ...props });
  },
  // logout
  logout: ({ payload, ...props }) => {
    return request(Api.logout, { body: payload, ...props });
  },
  // index config
  index: ({ payload, ...props }) => {
    return request(Api.index, { body: payload, ...props });
  },
  // index v5 config
  index_v5: ({ payload, ...props }) => {
    return request(Api.index_v5, { body: payload, ...props });
  },
  // message noread
  message_noread: ({ payload, ...props }) => {
    return request(Api.message_noread, { body: payload, ...props });
  },
  public_info: ({ payload, ...props }) => {
    return request(Api.public_info, { body: payload, ...props });
  },
  public_info_v4: ({ payload, ...props }) => {
    return request(Api.public_info_v4, { body: payload, ...props });
  },
  getStatsRate: ({ payload, ...props }) => {
    return request(Api.getStatsRate, { body: payload, ...props });
  },
  getLanguageFooterList: ({ payload, ...props }) => {
    return request(Api.language_footer_list, { body: payload, ...props });
  },
};
